var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeroMini',{attrs:{"msg":"Bihasic Cycle","subMsg":"A split sleeping pattern consisting of 6 hours at night and one midday nap."}}),_c('CycleCalculator',{attrs:{"msg":"Bihasic Sleeping Cycle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }